// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__ftFiZ","container":"Modal_container__4VN5k"};